module.exports = __webpack_public_path__ + "img/audio.0577d708.svg";